import { render, staticRenderFns } from "./OptionInputArea.vue?vue&type=template&id=23b0bfc9&scoped=true&"
import script from "./OptionInputArea.vue?vue&type=script&lang=ts&"
export * from "./OptionInputArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b0bfc9",
  null
  
)

export default component.exports